module.exports = __webpack_public_path__ + "media/src/images/icon_bm_detail-c7254de03fe047c9450ce0fedeb2f671.png";